import jiameiLogo from './label_logo/jiamei.jpg';
import JsBarcode from 'jsbarcode';
import QRCode from 'qrcode';

const generateBarcodes = async (expressNumber, orderNumber) => {
  const createBarcode = (text, options) => {
    const svg = document.createElementNS('http://www.w3.org/2000/svg', 'svg');
    svg.setAttribute('width', '100%');
    svg.setAttribute('height', '100%');
    svg.setAttribute('style', 'background: white;');
    
    try {
      JsBarcode(svg, text, {
        format: 'CODE128',
        xmlDocument: document,
        ...options,
        background: '#FFFFFF',
        lineColor: '#000000',
      });
    } catch (error) {
      console.error('Barcode generation error:', error);
      return '';
    }
    
    return svg.outerHTML;
  };

  // Generate top barcode
  const topBarcode = createBarcode(expressNumber || orderNumber, {
    width: 1.15, // Increased width by 15%
    height: 50,
    displayValue: true,
    fontSize: 12, // Slightly reduced font size
    textMargin: 4,
    margin: 5,
  });

  // Generate bottom barcode
  const bottomBarcode = createBarcode(expressNumber, {
    width: 1.6,  // Increased from 1.25 to 2 for wider barcode
    height: 55,  // Slightly increased height to maintain proportions
    displayValue: true,
    fontSize: 14,
    textMargin: 2,
    margin: 2,
  });

  // Generate QR code
  let qrDataUrl = '';
  try {
    qrDataUrl = await QRCode.toDataURL(expressNumber || orderNumber, {
      width: 150,
      margin: 1,
      errorCorrectionLevel: 'M',
      scale: 4,
    });
  } catch (error) {
    console.error('QR code generation error:', error);
    throw error;
  }

  return {
    topBarcode: `<div style="width: 100%; height: 100%; background: white;">${topBarcode}</div>`,
    bottomBarcode: bottomBarcode,
    qrCode: `<img src="${qrDataUrl}" style="width: 100px; height: 100px;" />`, // Smaller QR code
  };
};


const generateLabel = async (item) => {
  try {
    const { topBarcode, bottomBarcode, qrCode } = await generateBarcodes(item.express_number, item.order_number);
    if (!topBarcode || !bottomBarcode || !qrCode) {
      console.error('Failed to generate one or more barcodes');
      return null;
    }

    return `
    <style>
      @media print {
        * {
          -webkit-print-color-adjust: exact !important;
          print-color-adjust: exact !important;
          color-adjust: exact !important;
        }
        @page {
          size: auto;
          margin: 0mm;
        }
      }
    </style>
    <div style="font-family: -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, 'Helvetica Neue', Arial, sans-serif; border: 2px solid #000; padding: 8px; box-sizing: border-box; -webkit-print-color-adjust: exact; print-color-adjust: exact; -webkit-font-smoothing: antialiased; -moz-osx-font-smoothing: grayscale; zoom: 1;">
      <!-- Header Section -->
      <div style="margin-bottom: 0px;">
        <div style="display: flex; justify-content: space-between; align-items: center; margin-bottom: 4px;">
          <!-- Logo and Barcode -->
          <div style="display: flex; align-items: center; flex-grow: 1;">
            <img src="${jiameiLogo}" style="width: 85px; height: auto; margin-right: 3px;" />
            <div style="flex-grow: 1;">
              <div style="font-size: 12px; font-weight: bold; white-space: nowrap; padding-top: 10px; margin-left: 5px;">运单编号 / Tracking No.</div>
              <div style="display: flex; align-items: center;">
                <div style="max-width: 70%;">${topBarcode}</div>
                <div style="margin-left: 10px; display: flex; flex-direction: column; align-items: center; width: 80px;">
                  <div style="font-size: 18px; font-weight: bold; margin-top: -20px;">集包地</div>
                  <div style="font-size: 8px; color: #666; margin-top: -1px; letter-spacing: -0.2px;">DISTRIBUTE TO</div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <!-- Shipper Info Section -->
      <div style="border: 1px solid #000; margin-bottom: 4px; display: table; width: 100%;">
        <div style="display: table-row;">
          <div style="display: table-cell; width: 25%; padding: 4px; font-weight: bold; font-size: 13px; border-right: 1px solid #000; vertical-align: top;">
            <span style="font-weight: bold;">发货人信息</span><br/>SHIPPER INFO.
          </div>
          <div style="display: table-cell; padding: 4px; font-size: 9.5px; line-height: 1.2; font-weight: 500;">
            发货人/SHIPPER: ${item.sender_name || 'Coolala Boutique'}<br/>
            电话/TEL: ${item.sender_phone || '4168766068'}<br/>
            地址/ADDRESS: ${item.sender_address || 'Markham, CANADA'}<br/>
            退件地址/PACKAGE RETURNING ADDRESS:
          </div>
        </div>
      </div>

      <!-- Receiver Info Section -->
      <div style="border: 1px solid #000; margin-bottom: 8px; display: table; width: 100%;">
        <div style="display: table-row;">
          <div style="display: table-cell; width: 25%; padding: 4px; font-weight: bold; font-size: 13px; border-right: 1px solid #000; vertical-align: top;">
            <span style="font-weight: bold;">收件人信息</span><br/>RECEIVER INFO.
          </div>
          <div style="display: table-cell; padding: 4px; font-size: 9.5px; line-height: 1.2; font-weight: 500;">
            收件人/TO: ${item.label_address ? item.label_recipient : item.recipient_name}<br/>
            电话/TEL: ${item.label_address ? item.label_phone : (item.recipient_phone || '-')}<br/>
            地址/ADDRESS: ${item.label_address ? item.label_address : (item.recipient_address || '-')}
          </div>
        </div>
      </div>

      <!-- Delivery Acknowledgment Section -->
      <div style="border: 1px solid #000; margin-bottom: 8px; padding: 8px;">
        <div style="display: flex; justify-content: space-between; align-items: center;">
          <div style="flex-grow: 1; font-size: 9.5px; color: #000; line-height: 1.2; padding-right: 6px; border-right: 1px solid #000; font-weight: 500;">
            快件送到收件人地址，经收件人或收件人（寄件人）允许的代收人签名，视为送达。您的签字代表您已验收此包裹，并已确认商品信息无误，包装完好、没有划痕、没有破损等表面质量问题。国际件已消杀，做好内件防护。
          </div>
          <div style="margin-left: 10px; text-align: right; font-size: 9px; white-space: nowrap;">
            签收人/代签人： _________ <br/><br/>
            时间： _________
          </div>
        </div>
      </div>

      <!-- Barcode and Security Section -->
      <div style="border: 1px solid #000; margin-bottom: 8px; padding: 8px;">
        <div style="display: flex; justify-content: space-between; align-items: center;">
          <div style="text-align: left;">
            <div style="font-size: 10px; margin-bottom: 2px;" >订单号：${item.order_number}</div>
            ${bottomBarcode}
          </div>
          <div style="display: flex; flex-direction: column; text-align: left;">
            <div style="font-size: 8px; white-space: nowrap;">已签订安保协议(天津)</div>
            <div style="font-size: 17px; font-weight: bold; margin-top: 4px;">已验视</div>
          </div>
        </div>
      </div>

      <!-- QR Code and Short Address Section -->
      <div style="border: 1px solid #000; margin-bottom: 8px; padding: 6px; display: flex; align-items: center; justify-content: center;">
        <div style="width: 100px; height: 100px; margin-right: 12px;">${qrCode}</div>
        <div style="flex-grow: 1; text-align: center;">
          <div style="font-size: 20px; font-weight: bold;">${item.dest_route_label || 'dest_route_label'}</div>
          <div style="font-size: 22px; font-weight: bold;">${item.coding_mapping || 'coding_mapping'}</div>
        </div>
      </div>

    </div>
  `;
  } catch (error) {
    console.error('Failed to generate label:', error);
    return null;
  }
};

export default generateLabel;
